import _debounce from 'lodash/debounce';
import React from 'react';

/**
 * Provided an array of media queries and an associated
 * array of values, it will match a media query to a value
 * on resize and return it.
 * If no queries match, it will return a default value.
 */
export default function useMedia(queries, values, defaultValue) {
  const match = React.useCallback(() => {
    if (typeof window === 'undefined') {
      return defaultValue;
    }

    return (
      values[queries.findIndex(q => matchMedia(q).matches)] || defaultValue
    );
  }, [defaultValue, queries, values]);

  const [value, set] = React.useState(match);

  React.useEffect(() => {
    const handler = _debounce(() => set(match), 150);

    window.addEventListener('resize', handler);

    return () => window.removeEventListener('resize', handler);
  }, [match]);

  return value;
}
